import { gql } from "@apollo/client";

export const GET_WAREHOUSE_LOCATION_PAGE_LIST = gql`
    query GetWarehouseLocationPageList($request: WarehouseLocationInfoRequestInput!) {
        getWarehouseLocationPageList(request: $request) {
            totalCount
            totalPages
            warehouseLocationInfoList {
                id
                locationNo
                warehouseId
                buildTime
                locationOrderCount
            }
        }
    }
`;

export interface WarehouseLocationInfoType {
    id: number;
    locationNo: string;
    warehouseId: number;
    buildTime: number;
    locationOrderCount: number;
}

export interface WarehouseLocationInfoRequestInput {
    pageRequest?: {
        pageNum: number;
        pageSize: number;
    };
    filters?: {
        warehouseId?: number;
        warehouseIdList?: number[];
        locationNo?: string;
        buildTimeRange?: {
            start: string;
            end: string;
        };
    };
}

export interface GetWarehouseLocationPageListResponse {
    getWarehouseLocationPageList: {
        totalCount: number;
        totalPages: number;
        warehouseLocationInfoList: WarehouseLocationInfoType[];
    };
}

